import { createUseStyles } from 'react-jss';

export const useSourceInfoButtonStyles = createUseStyles({
  text: {
    textAlign: 'start',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '.875rem',
  },
  link: {
    flexGrow: 1,
    width: '100%',
  },
  button: {
    width: '100%',
    padding: '.3125rem',
  },
});
